/**
 * @generated SignedSource<<929704f88cfbd28fc168f89983752879>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderInlineDataFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type hooksHomeV2PickMorningStudioArticle$data = {
  readonly items: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly " $fragmentSpreads": FragmentRefs<"homeNativeArticleContentItemContent">;
      };
      readonly " $fragmentSpreads": FragmentRefs<"v2RecommendedForYouSponsorArticleQueueItemsEdge">;
    }>;
  } | null | undefined;
  readonly " $fragmentType": "hooksHomeV2PickMorningStudioArticle";
};
export type hooksHomeV2PickMorningStudioArticle$key = {
  readonly " $data"?: hooksHomeV2PickMorningStudioArticle$data;
  readonly " $fragmentSpreads": FragmentRefs<"hooksHomeV2PickMorningStudioArticle">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "hooksHomeV2PickMorningStudioArticle"
};

(node as any).hash = "effb8e3aa315b153fbc8f6cc712c348c";

export default node;
